// Значения подставляются CRA из .env.development (yarn start) или
// .env.production (yarn build) автоматически — переключаться вручную
// комментированием строк больше не нужно.
// Для локального переопределения без коммита используйте .env.development.local
// (см. https://create-react-app.dev/docs/adding-custom-environment-variables/).

export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME as string;
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL as string;
export const WS_URL = process.env.REACT_APP_WS_URL as string;
